import { useEffect } from "react";
import SellerProfileEditPage from "../../components/PageComponents/SellerProfileEditPage/SellerProfileEditPage";
import logAnalyticsEvent from '../../services/AnalyticsManager/AnalyticsManager';
import { GGAnalyticsEvents } from '../../services/AnalyticsManager/GGAnalyticsEvents';

const SellerRegistrationPage = () => {

  useEffect(() => {
    logAnalyticsEvent(GGAnalyticsEvents.SELLER_REGISTRATION_PAGE_LOADED);
  }, []);

  return (
    <SellerProfileEditPage isNewSeller={true} />
  );
};

export default SellerRegistrationPage;